export const common = {
  app: {
    title: "Belora",
    tagline: "Geolocated maintenance management",
  },
  nav: {
    ariaLabel: "Main navigation",
    skipToContent: "Skip to main content",
    toggleMenu: "Toggle menu",
    home: "Home",
    tech: "Technician",
    admin: "Admin",
    settings: "Settings",
    profile: "Profile",
    langSwitch: "Language switcher",
    language: "Language",
    langEn: "English",
    langEs: "Español",
    workflowManagement: "Workflow Management",
    fsmConfiguration: "FSM Configuration",
    workflows: "Workflows",
    states: "States",
    transitions: "Transitions",
    entityTypes: "Entity Types",
    documentTypes: "Document Types",
    entities: "Entities",
    roles: "Roles",
    welcome: "Welcome",
    administration: "Administration",
    users: "Users",
    customers: "Customers",
    locations: "Locations",
    stations: "Stations",
    devices: "Locks",
    map: "Map",
    bikes: "Bikes",
    materials: "Materials",
    bikeModels: "Bike Models",
    customerSwitcher: "Customer Switcher",
    requests: "Requests",
    notificationChannels: "Notification Channels",
    kpis: "Operations KPIs",
    budget: "Materials Budget",
    tracking: "Tracking",
    toggleColorScheme: "Toggle color scheme",
    palette: "Theme",
    paletteBelora: "Belora",
    paletteDefault: "Default",
  },
  common: {
    loading: "Loading...",
    error: "Error",
    required: "Required",
    invalidFormat: "Invalid format",
    loadError: "Could not load options. Refresh to retry.",
    actions: "Actions",
    save: "Save",
    cancel: "Cancel",
    clear: "Clear",
    create: "Create",
    edit: "Edit",
    update: "Update",
    delete: "Delete",
    yes: "Yes",
    no: "No",
    all: "All",
    hide: "Hide",
    show: "Show",
    copied: "Copied",
    confirm: "Confirm",
    unexpectedError: "An unexpected error occurred.",
    unknownError: "An unexpected error occurred. Please try again.",
    uploadError: "Upload failed. Please try again.",
    uploadErrorFile: 'Failed to upload "{{file}}". Please try again.',
    deletedSuccessfully: "Deleted successfully",
    selectCustomer: "Select a customer",
    noResults: "No results",
    search: "Search...",
    uploadFiles: "Upload files",
    filesUploaded: "{{count}} file(s) uploaded",
    addUrl: "Add URL",
    removeUrl: "Remove URL #{{index}}",
    invalidUrl: "Must be a valid URL (http:// or https://)",
    finalState: "final",
    deactivate: "Deactivate",
    reactivate: "Reactivate",
    deactivateConfirm: "Deactivate this record? This action is reversible.",
    deactivated: "Deactivated",
    manage: "Manage",
    view: "View",
    back: "Back",
    print: "Print",
    name: "Name",
    description: "Description",
    customer: "Customer",
    noCustomers: "No Customers",
    type: "Type",
    initial: "Initial",
    final: "Final",
    pickOne: "Pick one",
    noItems: "No items found.",
    success: "Success",
    import: "Import",
    export: "Export",
    deleteConfirm: "Are you sure you want to delete <b>{{name}}</b>?",
    undoneWarning: "This action cannot be undone.",
    notFound: "Not found",
    imageViewer: "Image viewer",
    copy: "Copy to clipboard",
    fieldRequired: "{{field}} is required",
    previousImage: "Previous image",
    nextImage: "Next image",
    status: "Status",
    statusCritical: "critical",
    statusWarning: "warning",
    readOnly: "Read-only",
    systemRole: "System",
  },
  sync: {
    online: "Online",
    offline: "Offline",
    syncing: "Syncing",
  },
  tasks: {
    empty: "No assigned tasks",
    checklist: "Checklist",
    notes: "Notes",
  },
  auth: {
    signOut: "Sign out",
    signOutAriaLabel: "Sign out {{name}}",
    signIn: "Sign in",
    register: "Sign up",
    email: "Email",
    password: "Password",
    confirmPassword: "Confirm Password",
    name: "Name",
    namePlaceholder: "Your name",
    passwordPlaceholder: "Your password",
    confirmPasswordPlaceholder: "Confirm your password",
    emailPlaceholder: "you@example.com",
    passwordMinLengthPlaceholder: "At least 6 characters",
    noAccount: "Don't have an account?",
    alreadyHaveAccount: "Already have an account?",
    passwordsDoNotMatch: "Passwords do not match",
    createAccount: "Create an account",
    magicLink: "Magic Link",
    passwordAuth: "Password",
    completeRegistrationTitle: "Complete your registration",
    completeRegistrationSubtitle:
      "Please set your password and optionally your phone number to finish setting up your account.",
    completeRegistrationSubmit: "Complete Registration",
    completeRegistrationSuccess: "Registration completed successfully.",
    completeRegistrationError: "Failed to complete registration",
    phone: "Phone",
    phonePlaceholder: "+123456789 (Optional)",
    registrationRestricted:
      "Registration is currently restricted to administrators. If you have been invited, please follow the link sent to you.",
    inviteUser: "Invite New User",
    sendInvitation: "Send Invitation",
    invitationCreated:
      "Invitation created! Copy the link below and send it to the user.",
    invalidEmail: "Invalid email",
    nameRequired: "Name is required",
    passwordTooShort: "Password must be at least 8 characters",
    passwordNeedsUppercase:
      "Password must contain at least one uppercase letter",
    passwordNeedsNumber: "Password must contain at least one number",
    profileUpdated: "Profile updated successfully",
    updateFailed: "Failed to update profile",
    noChanges: "No changes to save",
    preferredLanguage: "Preferred Language",
    preferredLanguageEn: "English",
    preferredLanguageEs: "Español",
    notificationChannels: "Notification Channels",
    notificationChannelsDesc:
      "Configure external notification channels for this customer.",
    channelCustomer: "Customer",
    channelCustomerRequired: "Select the customer this channel belongs to",
    channelLabel: "Label",
    channelType: "Type",
    channelRef: "Channel Ref",
    channelRefHint:
      'Uppercased, dashes → underscores. E.g. "belora-admin" → DISCORD_WEBHOOK_BELORA_ADMIN or EMAIL_BELORA_ADMIN_FROM.',
    channelEventTypes: "Event Types",
    channelActive: "Active",
    channelInactive: "Inactive",
    channelLanguage: "Language",
    channelCreate: "Add Channel",
    channelEdit: "Edit Channel",
    channelDeactivate: "Deactivate",
    channelReactivate: "Reactivate",
    channelNotifyRoles: "Notify Roles",
    channelNotifyRolesHint:
      "Only dispatch this channel when a recipient has one of these roles. Leave empty to always dispatch.",
    channelSaveSuccess: "Channel saved successfully",
    channelSaveError: "Failed to save channel",
    channelDeactivateSuccess: "Channel deactivated",
    channelReactivateSuccess: "Channel reactivated",
    channelEmpty: "No channels configured for this customer.",
    channelEnvStatus: "Env",
    channelEnvConfigured: "Configured",
    channelEnvNotConfigured: "Not configured",
    channelEnvVerify: "Click to verify env var",
    channelTestSend: "Send test",
    channelTestSuccess: "Test sent",
    channelTestFailed: "Test failed",
    channelTestEmailLabel: "Recipient email",
    channelTestEmailTitle: "Send test email",
    channelTestEmailConfirm: "Send",
    currentPassword: "Current Password",
    currentPasswordPlaceholder: "Enter your current password",
    currentPasswordRequired: "Current password is required",
    newPassword: "New Password",
    newPasswordPlaceholder: "Enter your new password",
    security: "Security",
    changePassword: "Change Password",
    passwordChanged: "Password changed successfully",
    passwordChangeFailed: "Failed to change password",
    loginFailed: "Login failed",
    settingsDescription:
      "Manage your account settings and security preferences",
  },
  routes: {
    tech: "Technician",
    techTasks: "Tasks",
    techMap: "Map",
    admin: "Admin",
    adminDashboard: "Dashboard",
    adminMap: "Fleet Map",
    adminWorkOrders: "Work Orders",
    adminInventory: "Inventory",
    settings: "Settings",
  },
  welcome: {
    title: "Welcome back, {{name}}!",
    subtitle: "Here is an overview of your account and permissions.",
    personalInfo: "Personal Information",
    personalInfoSubtitle: "Basic account details",
    customerAccess: "Customer Access",
    customerAccessSubtitle: "Organizations you belong to",
    noCustomer: "No customer assigned (Registered only)",
    rolesAndEntities: "Roles & Entities",
    rolesSubtitle:
      "Your active permissions and system identity within the current context.",
    noRoles: "No roles found for your user.",
    customerId: "Customer ID: {{id}}",
    entityId: "(Entity: {{id}})",
    jwtContent: "JWT Content",
    jwtSubtitle: "Raw session data and claims",
    jwtActiveCustomer: "Active Customer Claim: {{id}}",
    jwtNoActiveCustomer: "No active customer claim found in JWT",
    viewAll: "View all requests",
    noRequests: "No open requests",
    goAdmin: "Go to Administration",
    accessDenied: "Access Denied",
    pleaseSignIn: "Please sign in to view this page.",
    goSignIn: "Go to Sign in",
    newRequest: "New Repair Request",
    newRequestDesc: "Report a broken bike or maintenance issue",
    viewHistory: "View Requests",
    viewHistoryDesc: "Track the status of your submitted requests",
    quickActions: "Quick Actions",
    recentActivity: "Recent Activity",
    myLocations: "My Location",
    allLocations: "All Locations",
    systemDiagnostics: "System Diagnostics (Administrator)",
    createRequest: "New Request",
    viewDocTypeRequests: "View Requests",
    orderTracking: "Order tracking",
    orderTrackingDesc: "Delivery of material orders",
    orderTrackingCta: "View Tracking",
  },
  tracking: {
    title: "Order Tracking",
    subtitle: "Delivery of material orders",
    filterByLocation: "Filter by location",
    allLocations: "All locations",
    columnOrder: "Order",
    columnLocation: "Location",
    columnStatus: "Status",
    columnTrackingLink: "Tracking link",
    columnEstDelivery: "Est. delivery",
    columnNotes: "Notes",
    pendingLogistics: "Pending logistics",
    emptyState: "No shipments to track",
  },
  admin: {
    documentType: {
      title: "Document Types",
      nameLabel: "Name",
      descriptionLabel: "Description",
      descriptionPlaceholder: "Describe what this document type is for",
      deleteTitle: "Delete document type",
      deleteSuccess: "Document type deleted successfully",
      deleteError: "Failed to delete document type",
      fetchError: "Failed to fetch document types",
      search: "Search document types...",
    },
    state: {
      title: "States",
      search: "Search by name...",
      empty: "No states found",
      nameLabel: "Name",
      namePlaceholder: "e.g. In Progress",
      descriptionLabel: "Description",
      descriptionPlaceholder: "Describe this state",
      docTypeLabel: "Document Type",
      initialLabel: "Initial State",
      finalLabel: "Final State",
      initialDescription: "Where the document starts",
      finalDescription: "Where the document ends",
      flags: "Flags",
      notifyRolesLabel: "Notify Roles",
      notifyRolesDescription:
        "Roles to notify when a document enters this state",
      notifyRolesPlaceholder: "Select roles (optional)",
      translationEnLabel: "Name (English)",
      translationEsLabel: "Name (Spanish)",
      deleteTitle: "Delete state",
      deleteSuccess: "State deleted successfully",
      deleteError: "Failed to delete state",
      fetchError: "Failed to fetch states",
      saveError: "Failed to save state",
    },
    transition: {
      title: "Transitions",
      search: "Search transitions...",
      nameLabel: "Name",
      namePlaceholder: "e.g. Approve",
      fromStateLabel: "From State",
      fromStatePlaceholder: "Select start state",
      toStateLabel: "To State",
      toStatePlaceholder: "Select end state",
      executorsLabel: "Executor Entities",
      executorsPlaceholder: "Who can execute this?",
      docTypeLabel: "Document Type",
      translationEnLabel: "Name (English)",
      translationEsLabel: "Name (Spanish)",
      translationEsPlaceholder: "e.g. Aprobar",
      deleteTitle: "Delete transition",
      deleteSuccess: "Transition deleted successfully",
      deleteError: "Failed to delete transition",
      fetchError: "Failed to fetch transitions",
      saveError: "Failed to save transition",
      fetchModalError: "Failed to fetch modal data",
      visibleFieldsLabel: "Transition-Scoped Fields",
      visibleFieldsHint:
        "Checked fields only appear when executing this transition. Unchecked fields with no other restrictions appear in all transitions.",
    },
    fieldDefinition: {
      search: "Search field definitions...",
      addField: "Add Field",
      editTitle: "Edit: {{label}}",
      nameLabel: "Field Name (machine key)",
      namePlaceholder: "e.g. quantity_kg",
      nameDescription: "snake_case only. Cannot be changed after creation.",
      labelLabel: "Label",
      labelPlaceholder: "e.g. Quantity (kg)",
      typeLabel: "Field Type",
      sortOrderLabel: "Sort Order",
      requiredLabel: "Required",
      bikeStatusEffect: "Bike Status Side-Effect",
      bikeStatusEffectDescription:
        "When this transition is executed, automatically set the linked bike to this status. Leave empty for no effect.",
      bikeStatusNoEffect: "No effect",
      types: {
        text: "Text",
        textarea: "Textarea",
        number: "Number",
        email: "Email",
        date: "Date",
        select: "Select",
        boolean: "Boolean",
        material_picker: "Material Picker",
      },
    },
    entity: {
      title: "Entities",
      createTitle: "Create Entity",
      editTitle: "Edit Entity",
      nameLabel: "Name",
      namePlaceholder: "e.g. John Doe",
      typeLabel: "Entity Type",
      deleteTitle: "Delete entity",
      deleteSuccess: "Entity deleted successfully",
      deleteError: "Failed to delete entity",
      fetchError: "Failed to fetch entities",
      search: "Search entities",
    },
    role: {
      title: "Roles",
      createTitle: "Create Role",
      editTitle: "Edit Role",
      nameLabel: "Name",
      namePlaceholder: "e.g. mechanic",
      permissionsLabel: "Module Access",
      moduleAccessCount_one: "{{count}} module",
      moduleAccessCount_other: "{{count}} modules",
      requestsPermissionsLabel: "Requests — by document type",
      moduleAccessNoAccess: "No access",
      moduleAccessRead: "Read only",
      moduleAccessWrite: "Read & write",
      moduleAccessHasAccess: "Has access",
      descriptionLabel: "Description",
      descriptionPlaceholder: "e.g. Handles bike repairs and material requests",
      moduleGroups: {
        settings: "Configuration",
        reporting: "Reports",
        catalog: "Catalog",
        requests: "Requests",
      },
      customerLabel: "Customer",
      customerFilterPlaceholder: "Filter by customer",
      search: "Search roles...",
      deleteTitle: "Delete role",
      deleteSuccess: "Role deleted successfully",
      deleteError: "Failed to delete role",
      saveError: "Failed to save role",
      createSuccess: "Role created successfully",
      editSuccess: "Role updated successfully",
      noActiveCustomer: "No active customer",
      customerPlaceholder: "Choose a customer",
      customerRequired: "Choose the customer this role belongs to",
      noPermissionsTitle: "No permissions selected",
      noPermissionsMessage:
        "This role will have no permissions. Are you sure you want to {{action}} it without any permissions?",
      saveAnyway: "Save anyway",
      goBack: "Go back",
      permissionsLoadError: "Failed to load role permissions",
      permissions: {
        dashboardRead: "View Dashboard",
        dashboardWrite: "Manage Dashboard",
        usersRead: "View Users",
        usersWrite: "Manage Users",
        rolesRead: "View Roles",
        rolesWrite: "Manage Roles",
        bikesRead: "View Bikes",
        bikesWrite: "Manage Bikes",
        bikeCatalogRead: "View Bike Catalog",
        bikeCatalogWrite: "Manage Bike Catalog",
        materialsRead: "View Materials",
        materialsWrite: "Manage Materials",
        locationsRead: "View Locations",
        locationsWrite: "Manage Locations",
        stationsRead: "View Stations",
        stationsWrite: "Manage Stations",
        devicesRead: "View Devices",
        devicesWrite: "Manage Devices",
        requestsRead: "View Requests",
        requestsWrite: "Create & Manage Requests",
        fsm: "FSM Configuration",
        documentTypesRead: "View Document Types",
        documentTypesWrite: "Manage Document Types",
        customers: "Customer Management",
        reportingMaterialsBudget: "Materials Budget",
        reportingKpiOpsRead: "View Operations KPIs",
        reportingKpiOpsWrite: "Manage Operations KPIs",
        trackingOrderTrackingRead: "View Order Tracking",
      },
      permissionDescriptions: {
        dashboardRead: "The welcome dashboard screen",
        dashboardWrite: "The welcome dashboard screen",
        usersRead: "User accounts and role assignments within a customer",
        usersWrite: "User accounts and role assignments within a customer",
        rolesRead: "Customer roles and their permission sets",
        rolesWrite: "Customer roles and their permission sets",
        bikesRead: "Bike instances and their assignment status",
        bikesWrite: "Bike instances and their assignment status",
        bikeCatalogRead: "Bike models catalog",
        bikeCatalogWrite: "Bike models catalog",
        materialsRead: "Materials catalog used in maintenance requests",
        materialsWrite: "Materials catalog used in maintenance requests",
        locationsRead: "Locations within a customer",
        locationsWrite: "Locations within a customer",
        stationsRead: "Stations within a customer",
        stationsWrite: "Stations within a customer",
        devicesRead: "Connected devices (locks) within a customer",
        devicesWrite: "Connected devices (locks) within a customer",
        requestsRead: "Maintenance requests",
        requestsWrite: "Maintenance requests",
        fsm: "FSM workflow configuration (states, transitions)",
        documentTypesRead: "Document type configuration for requests",
        documentTypesWrite: "Document type configuration for requests",
        customers: "Customer accounts and settings",
        reportingMaterialsBudget: "Materials budget tracking per location",
        reportingKpiOpsRead: "Operational KPIs and performance metrics",
        reportingKpiOpsWrite: "Operational KPIs and performance metrics",
        trackingOrderTrackingRead:
          "Read-only Order Tracking view of MAT shipping entries",
      },
      names: {
        procurement: "Procurement",
      },
    },
    user: {
      title: "Users",
      editTitle: "Edit User",
      search: "Search by name or email...",
      emailLabel: "Email",
      nameLabel: "Name",
      roleLabel: "Primary Role",
      rolePlaceholder: "Select role",
      customerPlaceholder: "Choose a customer",
      rolesLabel: "Roles",
      customerLabel: "Customer",
      addRole: "Add Role",
      removeRole: "Remove role",
      removeRoleNamed: "Remove role {{role}}",
      fetchError: "Failed to fetch users",
      saveSuccess: "User updated successfully",
      saveError: "Failed to update user",
      addRoleSuccess: "Role added successfully",
      addRoleError: "Failed to add role",
      removeRoleSuccess: "Role removed successfully",
      removeRoleError: "Failed to remove role",
      customersLabel: "Customers",
      addCustomer: "Add Customer",
      removeCustomer: "Remove Customer",
      removeCustomerSuccess: "Customer removed successfully",
      removeCustomerError: "Failed to remove customer",
      assignCustomer: "Assign Customer",
      assignCustomerSuccess: "Customer assigned successfully",
      assignCustomerError: "Failed to assign customer",
      syncJwt: "Update permissions",
      syncJwtTooltip:
        "Re-applies this user's roles and permissions to their active session.",
      syncJwtSuccess: "JWT synced: {{count}} entity IDs",
      syncJwtError: "Failed to sync JWT",
      userLocationsLabel: "Assigned Locations",
      assignLocation: "Assign Location",
      removeLocation: "Unassign Location",
      setUserLocationsSuccess: "User locations updated successfully",
      setUserLocationsError: "Failed to update user locations",
      noCustomersForLocations:
        "User must be assigned to at least one customer before assigning locations.",
      deactivateConfirm:
        "Deactivate {{name}}? Their access to this customer will be removed.",
    },
    stations: {
      title: "Station Management",
      createTitle: "Create Station",
      editTitle: "Edit Station",
      nameLabel: "Station name",
      nameRequired: "A station name is required",
      locationLabel: "Location",
      locationRequired: "A location is required",
      locationFilter: "Filter by location",
      typeLabel: "Type",
      types: {
        geofence: "Geofence",
        analog_code: "Analog code",
        digital_single_point: "Digital single point",
      },
      geometryLabel: "Geometry (GeoJSON)",
      geometryDescription:
        "Paste a GeoJSON Polygon or MultiPolygon. Rings must be closed (first and last position equal).",
      geometryErrors: {
        required: "Geometry is required for a geofence station",
        invalidJson: "Geometry is not valid JSON",
        invalidGeometry: "Geometry is not a valid GeoJSON Polygon/MultiPolygon",
      },
      noGeometry: "No geometry",
      empty: "No stations found",
      createSuccess: "Station created successfully",
      updateSuccess: "Station updated successfully",
      deleteTitle: "Delete station",
      deleteConfirm: "Delete this station? Bikes parked at it are unaffected.",
      deleteSuccess: "Station deleted successfully",
      deleteFailed: "Could not delete the station",
      saveFailed: "Could not save the station",
    },
    devices: {
      title: "Lock Management",
      createTitle: "Register Lock",
      detailTitle: "Lock details",
      customerLabel: "Customer",
      providerLabel: "Provider",
      deviceTypeLabel: "Device type",
      providerDeviceIdLabel: "Provider device ID / MAC",
      providerDeviceIdDescription:
        "The identifier the provider uses for this lock, e.g. its MAC address.",
      providerDeviceIdRequired: "A provider device ID is required",
      fleetLabel: "Fleet",
      fleetDescription:
        "Which provider account this lock answers to. It decides whether remote commands may reach it, and is independent of the customer: a lock kept in inventory still belongs to the fleet it was bought for.",
      fleetRequired: "Choose the fleet this lock belongs to",
      fleetColumn: "Fleet",
      lockTypeLabel: "Lock type",
      capabilitiesLabel: "Capabilities",
      capabilitiesDescription:
        "Declared explicitly in Phase 1 — the manual state editor only offers fields these allow.",
      noCapabilities: "No capabilities declared",
      bikeLabel: "Bike",
      bikeDescription: "Leave empty to register the lock into inventory.",
      bikeRequired: "Select a bike to associate",
      inventory: "Inventory (no bike)",
      inventoryFilter: "Inventory only",
      empty: "No locks found",
      registerSuccess: "Lock registered successfully",
      saveFailed: "Could not save the lock",
      associateAction: "Associate",
      associateTitle: "Associate lock with a bike",
      associateSuccess: "Lock associated successfully",
      associateFailed: "Could not associate the lock",
      alreadyAssociatedError: "This bike already has a device associated.",
      disassociateAction: "Disassociate",
      stateTitle: "Manual state",
      lockStateLabel: "Lock state",
      lockStateDescription:
        "Transitional states are only offered when the lock declares lock_state_transitional.",
      connectivityLabel: "Connectivity",
      batteryPercentLabel: "Battery (%)",
      batteryVoltageLabel: "Battery (V)",
      ebikeBatteryLabel: "E-bike battery (%)",
      latitudeLabel: "Latitude",
      longitudeLabel: "Longitude",
      accuracyLabel: "Location accuracy (m)",
      tamperLabel: "Tamper detected",
      movementLabel: "Movement detected",
      impactLabel: "Impact detected",
      firmwareLabel: "Firmware version",
      stateSaveSuccess: "State saved successfully",
      stateSaveFailed: "Could not save the state",
    },
    map: {
      title: "Lock Map",
      empty: "No locks with registered coordinates",
      providerLabel: "Provider ID",
      fleetLabel: "Fleet",
      batteryLabel: "Battery",
      lockStateLabel: "State",
      batteryUnknown: "Unknown",
      lockStateLocked: "Locked",
      lockStateUnlocked: "Unlocked",
      lockStateUnknown: "Unknown",
      lockStateLocking: "Locking",
      lockStateUnlocking: "Unlocking",
      lockStateJammed: "Jammed",
      positionAgeLabel: "Position age",
      noPositionData: "No position data",
    },
    locations: {
      title: "Location Management",
      create: "Create Location",
      createTitle: "Create Location",
      editTitle: "Edit Location",
      name: "Name",
      city: "City",
      address: "Address",
      empty: "No locations found",
      nameLabel: "Location Name",
      cityLabel: "City",
      addressLabel: "Address",
      postalCodeLabel: "Postal Code",
      countryLabel: "Country",
      latLabel: "Latitude",
      lngLabel: "Longitude",
      keyMaxLength: "Max 3 characters",
      createSuccess: "Location created successfully",
      updateSuccess: "Location updated successfully",
      updateFailed: "Failed to update location",
      deleteTitle: "Delete Location",
      deleteWarning: "Are you sure you want to delete this location?",
      deleteSuccess: "Location deleted successfully",
      filterCustomer: "Customer",
      allCustomers: "All customers",
      typeLabel: "Location Type",
      types: {
        client: "Client",
        depot: "Depot",
      },
      deleteFailed: "Failed to delete location",
      deactivateSuccess: "Location deactivated successfully",
      deactivateFailed: "Failed to deactivate location",
      docTypesTitle: "Allowed Document Types",
      docTypesDescription:
        "Users assigned to this location will only see the selected document types.",
      docTypesEmpty: "No document types configured for this customer.",
      repairLink: {
        title: "Repair Request Link",
        description:
          "Share this link with users at this location to submit repair requests.",
      },
    },
    bikes: {
      title: "Bike Management",
      exportButton: "Export CSV",
      create: "Create Bike",
      createTitle: "Create Bike",
      editTitle: "Edit Bike",
      bike: "Bike",
      brand: "Brand",
      model: "Model",
      sku: "SKU",
      serialNumber: "Serial Number",
      beloraBikeId: "Belora Bike ID",
      clientBaseNumber: "Client Base Number",
      location: "Location",
      status: "Status",
      purchaseDate: "Purchase Date",
      lastRevisionDate: "Last Revision",
      acquisitionCost: "Acquisition Cost",
      wheelSize: "Wheel Size",
      empty: "No bikes found",
      locationLabel: "Location",
      statusLabel: "Status",
      brandLabel: "Brand",
      modelLabel: "Model",
      submodelLabel: "Submodel",
      skuLabel: "SKU",
      serialNumberLabel: "Serial Number",
      beloraBikeIdLabel: "Belora Bike ID",
      clientBaseNumberLabel: "Client Base Number",
      colorLabel: "Color",
      wheelSizeLabel: "Wheel Size",
      acquisitionCostLabel: "Acquisition Cost",
      createSuccess: "Bike created successfully",
      createFailed: "Failed to create bike",
      updateSuccess: "Bike updated successfully",
      updateFailed: "Failed to update bike",
      unknownModel: "Unknown Model",
      deleteTitle: "Delete Bike",
      deleteWarning: "Are you sure you want to delete this bike?",
      deleteSuccess: "Bike deleted successfully",
      search: "Search by ID, serial...",
      filterLocation: "Location",
      allLocations: "All locations",
      filterStatus: "Status",
      allStatuses: "All statuses",
      statuses: {
        available: "Available",
        in_repair: "In Repair",
        in_transit: "In Transit",
        en_garantia: "Under Warranty",
        retired: "Retired",
      },
    },
    bikeModels: {
      title: "Bike Models",
      createTitle: "Create Bike Model",
      editTitle: "Edit Bike Model",
      nameLabel: "Model Name",
      modelLabel: "Model",
      submodelLabel: "Submodel",
      codeLabel: "Code",
      codePlaceholder: "e.g. IEB-2026",
      codeFormatError: "Invalid format: XX-YYYY",
      codeDuplicateError: "Code already in use",
      materialsLabel: "Materials",
      manageMaterials: "Manage materials",
      deleteTitle: "Delete Bike Model",
      deleteWarning: "Are you sure you want to delete this bike model?",
      deleteSuccess: "Bike model deleted successfully",
      createSuccess: "Bike model created successfully",
      updateSuccess: "Bike model updated successfully",
      fetchError: "Failed to fetch bike models",
      empty: "No bike models found",
    },
    materials: {
      title: "Material Catalog",
      empty: "No materials found",
      createTitle: "Create Material",
      editTitle: "Edit Material",
      nameLabel: "Name",
      categoryLabel: "Category",
      clientCostLabel: "Client Cost",
      unitLabel: "Unit",
      skuLabel: "SKU",
      skuTaken: "SKU {{sku}} is already used by «{{name}}»",
      skuTakenDeactivated:
        "SKU {{sku}} is already used by «{{name}}», which is deactivated. Reactivate it or use another SKU",
      isConsumableLabel: "Consumable",
      deleteTitle: "Delete Material",
      deleteWarning: "Are you sure you want to delete this material?",
      deleteSuccess: "Material deleted successfully",
      createSuccess: "Material created successfully",
      updateSuccess: "Material updated successfully",
      materialLines: "Material Lines",
      materialLinesEmpty: "No material lines added.",
      selectMaterial: "Select material",
      searchMaterial: "Search material...",
      addMaterial: "Add {{name}}",
      decreaseMaterial: "Decrease {{name}}",
      increaseMaterial: "Increase {{name}}",
      quantity: "Quantity",
      addLine: "Add Line",
      removeLine: "Remove {{name}}",
      shipped: "Shipped",
      pending: "Pending",
      unitCost: "Unit Cost",
      subtotal: "Subtotal",
      totalCost: "Total",
      noPricesConfigured: "No prices configured for these materials.",
      stock: "Stock",
      stockEmpty: "No stock configured for this location.",
      quantityOnHand: "Qty on Hand",
      lastUpdated: "Last Updated",
      bikeModelsLabel: "Bike Models",
      viewBikeModels: "View compatible bike models",
      consumables: "Consumables",
      consumablesDescription: "Applies to all selected bikes",
      translationsSection: "Translations",
      nameEnLabel: "Name (EN)",
      nameEsLabel: "Name (ES)",
      exportButton: "Export CSV",
      importButton: "Import CSV",
      importTitle: "Import materials CSV",
      importSelectFile: "Select CSV file",
      importPlaceholder: "Click to select a file",
      importAdded: "Added",
      importModified: "Modified",
      importUnchanged: "Unchanged",
      importUnchangedDesc: "rows with no changes",
      importChanges: "Changes",
      importConfirm: "Confirm {{count}} changes",
      importValidationError: "Validation errors",
      importSuccess: "Import completed",
      importError: "Error importing materials",
      relationsExportButton: "Export Relations CSV",
      relationsImportButton: "Import Relations CSV",
      relationsImportTitle: "Import material-model relations CSV",
      relationsImportSuccess: "Relations updated",
      relationsImportError: "Error importing relations",
      diffAdded: "Added",
      diffRemoved: "Removed",
      diffUnchanged: "Unchanged",
      bikeModelCode: "Model code",
      bikeModelName: "Model name",
      strategy: "Import strategy",
      strategyReplace: "Replace",
      strategyMerge: "Merge",
      strategyReplaceHint: "Replaces all relations for materials in the CSV",
      strategyMergeHint: "Only adds new relations, keeps existing ones",
      relationsConfirm: "Confirm changes",
      cancel: "Cancel",
      searchPlaceholder: "Search by name, SKU...",
      categoryPlaceholder: "All categories",
    },
    stock: {
      qtyLabel: "Qty on Hand",
      saveFor: "Save stock for {{name}}",
    },
    entityType: {
      title: "Entity Types",
      createTitle: "Create Entity Type",
      editTitle: "Edit Entity Type",
      nameLabel: "Name",
      namePlaceholder: "e.g. Role",
      descriptionLabel: "Description",
      descriptionPlaceholder: "Describe what this entity type is for",
      deleteTitle: "Delete entity type",
      deleteSuccess: "Entity type deleted successfully",
      deleteError: "Failed to delete entity type",
      fetchError: "Failed to fetch entity types",
      search: "Search entity types...",
    },
    request: {
      title: "Requests",
      referenceNo: "Reference No.",
      titleLabel: "Title",
      documentType: "Request Type",
      priority: "Priority",
      status: "Status",
      createdBy: "Created By",
      createdAt: "Created",
      lastUpdate: "Last Update",
      total: "Total",
      type: "Type",
      actionRequired: "Action Required",
      createNew: "Create Request",
      viewDetails: "View Details",
      viewRows: "List view",
      viewTable: "Table view",
      showFilters: "Show filters",
      hideFilters: "Hide filters",
      export: "Export",
      exportDownload: "Download CSV ({{count}} selected)",
      selectRow: "Select order {{reference}}",
      exportColumnCode: "code",
      exportColumnName: "name",
      exportColumnTotal: "total",
      exportFailed: "Could not export the selected orders",
      low: "Low",
      medium: "Medium",
      high: "High",
      critical: "Critical",
      fetchError: "Failed to fetch requests",
      createSuccess: "Request created successfully",
      createError: "Failed to create request",
      location: "Location",
      bike: "Bike",
      bikes: "Bikes",
      payload: "Payload",
      availableActions: "Available Actions",
      consumedMaterials: "Consumed Materials",
      consumedMaterialsHint:
        "Declare materials used during the failed repair attempt.",
      transitionRequiredFieldsHint:
        "The following information is required to complete this transition:",
      executeTransition: "Execute Transition",
      transitionErrorNamed: 'Error executing "{{name}}"',
      fieldsRequired: "{{count}} required field(s) still need to be filled in.",
      executeTransitionConfirm:
        "Are you sure you want to execute <1>{{name}}</1>?",
      selectDocumentType: "Select request type",
      selectLocation: "Select location",
      selectBike: "Select bike",
      selectBikes: "Select bikes",
      reassignBike: "Reassign Bike",
      reassignBikeHint: "Select the correct bike for this repair request.",
      history: "History",
      state: "Status",
      statusFilter: "Status",
      statusActive: "Active",
      statusFinished: "Finished",
      deactivateConfirm: "Deactivate this request? This action is reversible.",
      noDocTypesConfigured:
        "Contact your administrator to configure request types.",
      adminEditMaterialLines: "Edit material lines",
      adminEditFields: "Edit fields",
      shipmentSection: "Shipment",
      shipmentSectionHint:
        "Declare how many units of each material are being shipped now.",
      shipmentIncrement: "This shipment",
      shipmentAllShipped: "All lines have already been fully shipped.",
      shipmentFillAllPending: "Ship all pending",
      adminEditBike: "Affected bike",
      adminEditRequestDate: "Request date",
      adminEditCreatedBy: "Created by",
      adminEditCreatedByPlaceholder: "Search entity...",
      adminEditAddLine: "Add line",
      adminEditRemoveLine: "Remove line",
      adminEditShippedHint: "{{count}} unit(s) already shipped",
      adminEditShippedQuantity: "Shipped",
      discountPercent: "Discount (%)",
    },
  },
  settings: {
    fsmWorkflows: {
      dashboard: "FSM Administration",
      dashboardSubtitle:
        "Manage the Finite State Machine configuration for the Yalana network.",
      documentTypes: "Document Types",
      documentTypesDescription:
        "Define different types of documents like Work Orders, Tickets, etc.",
      states: "States",
      statesDescription:
        "Configure the possible states for each document type.",
      transitions: "Transitions",
      transitionsDescription:
        "Set up the possible movements between states and who can execute them.",
      entities: "Entities",
      entitiesDescription:
        "Create and manage specific instances of entities (users, roles, etc.).",
      entityTypes: "Entity Types",
      entityTypesDescription:
        "Manage types of entities like Users, Roles, or Departments.",
      workflowEditor: "Workflow Editor",
      workflowEditorDescription:
        "Visualize and analyze the FSM graph for each document type.",
      workflowEditorInstructions:
        "Double-click to edit. Drag handles to connect/reconnect.",
      addState: "Add State",
      manageFields: "Fields",
      autoLayout: "Layout",
      autoLayoutTitle: "Auto-layout nodes",
      refreshTitle: "Refresh from server",
      noWorkflowData:
        'No states or transitions defined. Click "Add State" to begin.',
      workflows: "Workflows",
      currentState: "Current State",
      assignedTo: "Assigned To",
      noActions: "No actions",
      authorizedEntities: "Authorized Entities:",
      noRestrictedEntities: "No restricted entities (Public)",
      adminEditBadge: "Admin Edit",
      adminEditToggleLabel: "Allow admin edit",
      adminEditToggleTooltip:
        "When enabled, admins can edit this document type without a migration or deploy.",
      createState: "Create State",
      editState: "Edit State",
      createTransition: "Create Transition",
      editTransition: "Edit Transition",
      deleteStateConfirm:
        "Are you sure you want to delete state <b>{{name}}</b>?",
      deleteTransitionConfirm:
        "Are you sure you want to delete transition <b>{{name}}</b>?",
      fieldDefinitionEmpty:
        "No fields defined yet. Add fields to collect structured data with this document type.",
      metadataLoadError: "Failed to load initial metadata",
      workflowLoadError: "Failed to load workflow data",
      reconnectError: "Failed to update transition on reconnect",
      executeBy: "By {{name}}",
      transitionSuccess: "Transition executed successfully",
      transitionError: "Failed to execute transition",
    },
    customers: {
      title: "Customer Management",
      create: "Create Customer",
      createTitle: "Create Customer",
      editTitle: "Edit Customer",
      search: "Search by name or slug...",
      name: "Name",
      slug: "Slug",
      created: "Created",
      nameLabel: "Customer Name",
      slugLabel: "Slug",
      invalidSlug:
        "Slug must contain only lowercase letters, numbers and hyphens",
      slugHelp:
        "URL-friendly identifier. Use lowercase letters, numbers and hyphens.",
      slugHelpEdit:
        "Changing the slug affects all existing URLs for this customer. Make sure to update any bookmarks or links.",
      noCustomers: "No customers found",
      createSuccess: "Customer created successfully",
      createFailed: "Failed to create customer",
      updateSuccess: "Customer updated successfully",
      updateFailed: "Failed to update customer",
      deleteTitle: "Delete Customer",
      deleteWarning:
        "Are you sure you want to delete this customer? This action is permanent and will delete all associated data including documents, workflows, and requests.",
      deleteSuccess: "Customer deleted successfully",
      deleteError: "Failed to delete customer",
      status: "Status",
      statusOperational: "Operational",
      statusIncomplete: "Incomplete",
      completenessTitle: "Completeness: {{name}}",
      completenessLoadError: "Failed to load completeness status",
      completenessFsmInfoTitle: "FSM workflow (informational)",
      completenessGoToFix: "Fix",
    },
  },
  reporting: {
    materialsBudget: {
      title: "Materials Budget",
      from: "From",
      to: "To",
      noActiveTitle: "No Active Period",
      noActive: "No active budget period for today.",
      addPeriod: "Add Period",
      createSuccess: "Budget period created.",
      createError: "Failed to create budget period.",
      amount: "Amount (€)",
      history: "History ({{count}} periods)",
      hideHistory: "Hide history",
      status: "Status",
      superseded: "Replaced",
    },
  },
  fsm: {
    documentTypes: {
      workOrder: { label: "Work Order" },
      maintenance: { label: "Maintenance" },
    },
    states: {
      draft: { label: "Draft" },
      pending: { label: "Pending" },
      inProgress: { label: "In Progress" },
      completed: { label: "Completed" },
    },
  },
  pagination: {
    summary: "{{from}}–{{to}} of {{total}}",
    rowsPerPage: "Rows per page",
  },
  repair: {
    sections: {
      bike: "1. Select Bicycle",
      details: "2. Incident Details",
      severity: "3. Severity",
    },
    form: {
      title: "Report a Repair",
      bike: "Select Bike",
      bikeSearch: "Search by serial, brand or model...",
      motives: "What needs to be repaired?",
      submit: "Submit Repair Request",
      humanVerification: "Human verification",
    },
    success: {
      title: "Request Received!",
      message: "Your repair request has been submitted successfully.",
      referenceLabel: "Reference Number",
      newRepair: "Report Another Issue",
    },
    error: {
      duplicate: "This bike already has an open repair request",
      title: "Submission error",
    },
    motive: {
      loose_grips: "Loose Grips",
      hard_gears: "Hard Gears",
      pedals_out: "Pedals Out",
      flat_tire: "Flat Tire",
      brakes_dont_stop: "Brakes Don't Stop Properly",
      brakes_loud_noise: "Brakes Make a Loud Noise",
      chain_comes_out: "Chain Comes Out",
      loose_saddle: "Loose Saddle",
      broken_lock: "Broken Lock",
      lost_key: "Lost Key",
      other: "Other",
    },
    field: {
      prohibits_use: "Prohibits Bicycle Use",
      repair_photo: "Repair Photo",
      materials_used: "Materials Used",
    },
  },
  mat: {
    field: {
      tracking_url: "Tracking URL",
    },
  },
  warranty: {
    field: {
      description: "Problem Description",
      repair_photo: "Photo Evidence",
      photoCount_one: "photo",
      photoCount_other: "photos",
    },
  },
  notifications: {
    title: "Notifications",
    empty: "No new notifications",
    markAllRead: "Mark all as read",
    unread: "{{count}} unread notifications",
    pushPrompt: {
      title: "Enable Notifications",
      description:
        "Allow notifications to be alerted when requests need your attention.",
      allow: "Allow Notifications",
      dismiss: "Not Now",
      enable: "Enable Notifications",
    },
    preferences: {
      title: "Notification Preferences",
      description: "Choose which notifications you want to receive.",
      "fsm.transition": "Status changes",
      "fsm.created": "New requests",
      saved: "Preferences saved",
      saveFailed: "Failed to save preferences",
    },
  },
  pwa: {
    installPrompt: {
      title: "Add to Home Screen",
      description:
        "Install Belora on your device for fast access to requests and repairs.",
      descriptionIos:
        "Tap the Share icon then 'Add to Home Screen' to install Belora.",
      descriptionFirefox:
        "Open the menu (⋮) and tap 'Add to Home Screen' to install Belora.",
      install: "Install",
      dismiss: "Not Now",
      ok: "Got It",
    },
  },
  availableBudget: {
    title: "Available budget",
    noBudget: "No budget defined",
    locationCount_one: "{{count}} location",
    locationCount_other: "{{count}} locations",
    exceededCount_one: "{{count}} exceeded",
    exceededCount_other: "{{count}} exceeded",
    exceeded: "Budget exceeded",
    legendUsed: "Used",
    legendToOrder: "To order",
    legendAvailable: "Available",
    barAriaLabel: "Used {{used}}, to order {{toOrder}}, of {{total}}",
  },
  budgetProjection: {
    orderTotal: "Order total",
    availableToday: "Available today ({{location}})",
    availableIfApproved: "Available if approved",
    noBudget: "No budget defined",
  },
  budgetDashboard: {
    title: "Materials Budget",
    location: "Location",
    budgetTotal: "Budget",
    spent: "Spent",
    available: "Available",
    utilization: "Usage",
    utilizationAriaLabel: "Budget usage: {{pct}}%",
    totalBudget: "Total Budget",
    totalSpent: "Total Spent",
    totalAvailable: "Total Available",
    noLocations: "No locations assigned to your account.",
    noBudget: "No active budget",
    accessDenied: "Access denied. Procurement role required.",
  },
  kpis: {
    title: "Operations KPIs",
    subtitle: "Fleet performance and activity by date range",
    dateFrom: "From",
    dateTo: "To",
    filterLocations: "Filter by location",
    filterExecutors: "Filter by executor",
    allLocations: "All locations",
    allExecutors: "All executors",
    apply: "Apply",
    fleetTotal: "Fleet Total",
    active: "Active",
    inactive: "Inactive",
    recoveredOperability: "Recovered Operability",
    requestsHandled: "Requests Handled",
    inactiveByState: "Inactive by State",
    byLocation: "By Location",
    byExecutor: "By Executor",
    noData: "No data for selected period",
    locationSection: "{{name}} — {{total}} bikes",
    accessDenied: "Access denied. Admin role required.",
    summary: {
      title: "Operations Summary",
      customer: "Customer",
      noData: "No customers found",
    },
  },
  modules: {
    admin: {
      dashboard: "Dashboard",
      locations: "Locations",
      stations: "Stations",
      devices: "Devices",
      bikes: "Bikes",
      bikeCatalog: "Bike Catalog",
      materials: "Materials",
      users: "Users",
      roles: "Roles",
      fsmWorkflows: "FSM Workflows",
      documentTypes: "Document Types",
    },
    settings: {
      customers: "Customers",
    },
    reporting: {
      kpiOps: "Operations KPIs",
      materialsBudget: "Materials Budget",
    },
    requests: "Requests",
    portal: {
      bikes: "Portal — Bikes",
    },
    tracking: {
      orderTracking: "Order Tracking",
    },
  },
} as const;
